var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefreshingAmico(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-21"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-21",
    cx: 252.01,
    cy: 337.65,
    rx: 228.58,
    ry: 134.29,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-21",
    d: "M229.47,332.66,321,385.5a10.89,10.89,0,0,0,9.82,0l79.8-45.35c2.71-1.56,2.71-4.1,0-5.67l-91.46-52.83a10.86,10.86,0,0,0-9.82,0L229.47,327C226.75,328.56,226.75,331.09,229.47,332.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-21",
    d: "M189.45,376.58c-21,11.64-55,11.64-76,0s-21-30.54,0-42.19,55-11.66,76,0S210.45,364.92,189.45,376.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-21",
    d: "M443.2,387.48c-17.46,9.68-45.75,9.68-63.21,0s-17.46-25.38,0-35.07,45.75-9.69,63.21,0S460.65,377.8,443.2,387.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-21",
    d: "M137.3,397.06l-3.54,2s-31.8,2-53-10.2C56,374.62,49,354.22,49,354.22l3.54-2s39.6,9.59,56.54,20A120.79,120.79,0,0,1,137.3,397.06Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.64,291.69l1.92-1.11a2.25,2.25,0,0,0,.91-1.21l14.22-57.48a2.39,2.39,0,0,0-.21-1.51L342,226a.82.82,0,0,0-1.12-.3l-1.92,1.1A2.25,2.25,0,0,0,338,228l-15.06,60.86a1.15,1.15,0,0,0,.52,1.21l2.75,1.59A1.63,1.63,0,0,0,327.64,291.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.71,231.13l-3.35,1.94a2,2,0,0,0-.23-.76L338.62,228c-.2-.34-.43-.35-.56-.08a2.33,2.33,0,0,1,.85-1.05l1.92-1.1a.82.82,0,0,1,1.13.3l2.52,4.37A2.22,2.22,0,0,1,344.71,231.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.61,228l2.52,4.36a2.33,2.33,0,0,1,.22,1.51L327.12,291.3a.59.59,0,0,1-.91.39l-2.75-1.59a1.15,1.15,0,0,1-.52-1.21L338,228C338.11,227.59,338.39,227.56,338.61,228Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.14,336.28l-7.89-4.56a4.66,4.66,0,0,1-1.6-1.73l-82.51-173.4a1.34,1.34,0,0,1,.54-1.73l1.2-.7a2.37,2.37,0,0,1,2.14,0l7.89,4.56a4.75,4.75,0,0,1,1.6,1.73L400,333.85a1.36,1.36,0,0,1-.54,1.73l-1.21.7A2.35,2.35,0,0,1,396.14,336.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,159.88l-1.2.69a1.37,1.37,0,0,0-.54,1.74L396.79,335.7a1.12,1.12,0,0,0,1.6.5l1.2-.7a1.36,1.36,0,0,0,.54-1.73L317.62,160.38A1.12,1.12,0,0,0,316,159.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.42,160.31a1.12,1.12,0,0,0-1.51-.36l-1.21.7a1.32,1.32,0,0,0-.62.87l-10-5.8a1.33,1.33,0,0,1,.63-.86l1.2-.69a2.31,2.31,0,0,1,2.14,0l7.89,4.55A4.7,4.7,0,0,1,317.42,160.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.36,267.77v.06a.13.13,0,0,0,0-.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.36,267.84v3.85a2.28,2.28,0,0,1-1.31,1.86,7.68,7.68,0,0,1-6.92-.14L352.67,251.2a1,1,0,0,1-.59-.81v-3.85h0a1,1,0,0,0,.58.82l38.46,22.21a7.68,7.68,0,0,0,6.92.13A2.25,2.25,0,0,0,399.36,267.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.05,269.7a7.68,7.68,0,0,1-6.92-.13l-38.46-22.21a.87.87,0,0,1,0-1.65l3.83-2.21a3.18,3.18,0,0,1,2.85,0l38.47,22.21a2.59,2.59,0,0,1,1.54,2.13A2.25,2.25,0,0,1,398.05,269.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.46,287.31l-87.78,1.88a5.78,5.78,0,0,0-2.31.64l-1.21.7a.65.65,0,0,0,0,1.23l17.2,7.18a5.27,5.27,0,0,0,2.3.59l68.46-1.46a5.79,5.79,0,0,0,2.3-.65l1.2-.69a2.38,2.38,0,0,0,1.07-1.86v-6.35A1.21,1.21,0,0,0,406.46,287.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.35,296.8v-6.35a1.21,1.21,0,0,0-1.23-1.21l-87.79,1.88c-.69,0-.76.3-.17.64l17.2,7.18a5.27,5.27,0,0,0,2.3.59l68.46-1.47A1.26,1.26,0,0,0,404.35,296.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.69,288.52v6.35a2.36,2.36,0,0,1-1.07,1.85l-1.2.7a5.62,5.62,0,0,1-2.3.64,1.26,1.26,0,0,0,1.23-1.26v-6.35a1.19,1.19,0,0,0-.48-1l3.34-1.93A1.19,1.19,0,0,1,407.69,288.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.76,295.5h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.42,294h0l-2.66,1.54a1.18,1.18,0,0,0,.48-1.09,3.75,3.75,0,0,0-1.67-2.89,1.27,1.27,0,0,0-1.06-.19l2.55-1.47a1.16,1.16,0,0,1,1.19.11,3.7,3.7,0,0,1,1.67,2.9A1.13,1.13,0,0,1,400.42,294Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.25,294.41a3.75,3.75,0,0,0-1.67-2.89,1.27,1.27,0,0,0-1.06-.19l-.22.13h0l-60.72,35,2.35,4.1,60.84-35.12A1.14,1.14,0,0,0,398.25,294.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.25,294.41a3.75,3.75,0,0,0-1.67-2.89,1.27,1.27,0,0,0-1.06-.19l-.22.13h0l-60.72,35,2.35,4.1,60.84-35.12A1.14,1.14,0,0,0,398.25,294.41Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.75,326.64a3.7,3.7,0,0,1,1.67,2.9c0,1.06-.75,1.49-1.67,1a3.68,3.68,0,0,1-1.68-2.89C334.07,326.54,334.82,326.11,335.75,326.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.51,163.75a1.23,1.23,0,0,0-1.06-.18l-.22.12h0L243.6,200.44l2.35,4.1,63.74-36.8a1.17,1.17,0,0,0,.49-1.09A3.8,3.8,0,0,0,308.51,163.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.51,163.75a1.23,1.23,0,0,0-1.06-.18l-.22.12h0L243.6,200.44l2.35,4.1,63.74-36.8a1.17,1.17,0,0,0,.49-1.09A3.8,3.8,0,0,0,308.51,163.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.35,166.19h0l-2.66,1.53a1.17,1.17,0,0,0,.48-1.08,3.8,3.8,0,0,0-1.67-2.9,1.23,1.23,0,0,0-1.06-.18L310,162.1a1.17,1.17,0,0,1,1.18.1,3.71,3.71,0,0,1,1.68,2.9A1.16,1.16,0,0,1,312.35,166.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,325.16h0a100.11,100.11,0,0,1-85.6-92.37l-4.95-28.52,63.27-36.54L315.89,195c14.29,53.81,35.95,82.54,79.47,96.44h0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-21",
    d: "M373.19,292.48c-14.06-7.64-29.54-13.61-40.56-25.21-8.79-9.26-14-21.37-17.66-33.6a180.47,180.47,0,0,1-7.35-40.83c-.3-4.81-.71-10.27-4.46-13.3a14.76,14.76,0,0,0-8.42-3.17l-20.78,12c.23,4,3,7.62,4,8.65a26.22,26.22,0,0,0,4.88,4c1.06.65-.57,9.81-.75,10.94-.78,4.78-4.46,7.42-5.28,12.05a100.13,100.13,0,0,0,12.83,68.78c4.67,7.7,13.48,13.5,21.2,17.91,7.53,4.32,14.23,6.13,22.51,8.72,4.12,1.3,8.43,3,8.43,3,.33.76,1.41,4.65,1.41,4.65l42.47-24.52C382.74,298.09,377.91,295.05,373.19,292.48Z",
    style: {
      opacity: 0.07
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Glass--inject-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--glass--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387,239.65l.66,19.36h0a2.17,2.17,0,0,0,.21.84,4,4,0,0,0,1.79,1.77,10.93,10.93,0,0,0,9.63,0,4,4,0,0,0,1.78-1.77,2.21,2.21,0,0,0,.2-.74h0a1.7,1.7,0,0,0,0-.22h0l.65-19.23a3,3,0,0,0,.57-1.59l-.8,23.44v.24a3.72,3.72,0,0,1-2.11,2.76,11.29,11.29,0,0,1-10.22,0,3.63,3.63,0,0,1-2.11-2.88v-.07l-.8-23.49A3.06,3.06,0,0,0,387,239.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,239.65l.66,19.36h0a2.17,2.17,0,0,0,.21.84,4,4,0,0,0,1.79,1.77,10.93,10.93,0,0,0,9.63,0,4,4,0,0,0,1.78-1.77,2.21,2.21,0,0,0,.2-.74h0a1.7,1.7,0,0,0,0-.22h0l.65-19.23a3,3,0,0,0,.57-1.59l-.8,23.44v.24a3.72,3.72,0,0,1-2.11,2.76,11.29,11.29,0,0,1-10.22,0,3.63,3.63,0,0,1-2.11-2.88v-.07l-.8-23.49A3.06,3.06,0,0,0,387,239.65Z",
    style: {
      fill: "#fff",
      opacity: 0.8300000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.79,241.23a12.56,12.56,0,0,0,11.36,0,5.24,5.24,0,0,0,1.78-1.57l-.65,19.23h0v.22h0a2.21,2.21,0,0,1-.2.74,4,4,0,0,1-1.78,1.77,10.93,10.93,0,0,1-9.63,0,4,4,0,0,1-1.79-1.77,2.17,2.17,0,0,1-.21-.84h0L387,239.65A5.3,5.3,0,0,0,388.79,241.23Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.79,241.23a12.56,12.56,0,0,0,11.36,0,5.24,5.24,0,0,0,1.78-1.57l-.65,19.23h0v.22h0a2.21,2.21,0,0,1-.2.74,4,4,0,0,1-1.78,1.77,10.93,10.93,0,0,1-9.63,0,4,4,0,0,1-1.79-1.77,2.17,2.17,0,0,1-.21-.84h0L387,239.65A5.3,5.3,0,0,0,388.79,241.23Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.28,259.07a3.39,3.39,0,0,1-2,2.56,10.93,10.93,0,0,1-9.63,0,3.35,3.35,0,0,1-2-2.56l-.57-16.53c-.06-1.09.66-2.19,2.16-3a12,12,0,0,1,10.42,0c1.5.83,2.22,1.93,2.16,3Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.29,261.63a10.93,10.93,0,0,1-9.63,0c-2.66-1.49-2.66-3.9,0-5.39a10.93,10.93,0,0,1,9.63,0C401.94,257.73,401.94,260.14,399.29,261.63Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.28,259.07a3.39,3.39,0,0,1-2,2.56,10.93,10.93,0,0,1-9.63,0,3.35,3.35,0,0,1-2-2.56l-.57-16.53c-.06-1.09.66-2.19,2.16-3a12,12,0,0,1,10.42,0c1.5.83,2.22,1.93,2.16,3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.68,245.31a12,12,0,0,1-10.42,0c-2.88-1.6-2.88-4.19,0-5.79a12,12,0,0,1,10.42,0C402.56,241.12,402.56,243.71,399.68,245.31Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.26,245.31a12.16,12.16,0,0,0,9.18.55c-4,.69-7.7-1.16-7.38-3.55l0-.15a9.39,9.39,0,0,1-2.3-.93,6.49,6.49,0,0,1-.92-.64C386.5,242.12,387,244,389.26,245.31Z",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.44,238v0a3.06,3.06,0,0,0,.56,1.58,5.3,5.3,0,0,0,1.79,1.58,12.56,12.56,0,0,0,11.36,0,5.24,5.24,0,0,0,1.78-1.57,3,3,0,0,0,.57-1.59c.05-1.23-.73-2.46-2.35-3.39a12.56,12.56,0,0,0-11.36,0C387.19,235.6,386.41,236.82,386.44,238Zm2.71-3a12.19,12.19,0,0,1,10.64,0c2.94,1.63,2.94,4.28,0,5.91a12.25,12.25,0,0,1-10.64,0C386.22,239.28,386.22,236.63,389.15,235Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.44,238v0a3.06,3.06,0,0,0,.56,1.58,5.3,5.3,0,0,0,1.79,1.58,12.56,12.56,0,0,0,11.36,0,5.24,5.24,0,0,0,1.78-1.57,3,3,0,0,0,.57-1.59c.05-1.23-.73-2.46-2.35-3.39a12.56,12.56,0,0,0-11.36,0C387.19,235.6,386.41,236.82,386.44,238Zm2.71-3a12.19,12.19,0,0,1,10.64,0c2.94,1.63,2.94,4.28,0,5.91a12.25,12.25,0,0,1-10.64,0C386.22,239.28,386.22,236.63,389.15,235Z",
    style: {
      fill: "#fff",
      opacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.15,240.91a12.25,12.25,0,0,0,10.64,0c2.94-1.63,2.94-4.28,0-5.91a12.19,12.19,0,0,0-10.64,0C386.22,236.63,386.22,239.28,389.15,240.91Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.15,240.91a12.25,12.25,0,0,0,10.64,0c2.94-1.63,2.94-4.28,0-5.91a12.19,12.19,0,0,0-10.64,0C386.22,236.63,386.22,239.28,389.15,240.91Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.74,240.26a5.85,5.85,0,0,1-.95.65,12.25,12.25,0,0,1-10.64,0,6.32,6.32,0,0,1-.95-.65,6.37,6.37,0,0,1,1.06-.74,12,12,0,0,1,10.42,0A6.37,6.37,0,0,1,400.74,240.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.74,240.26a5.85,5.85,0,0,1-.95.65,12.25,12.25,0,0,1-10.64,0,6.32,6.32,0,0,1-.95-.65,6.37,6.37,0,0,1,1.06-.74,12,12,0,0,1,10.42,0A6.37,6.37,0,0,1,400.74,240.26Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.68,239.52l-.27-.14h0l-.44-.2a10.29,10.29,0,0,0-2.67-.72c-.26,0-.52-.06-.77-.08l-.67,0h-1.08a13.24,13.24,0,0,0-2.39.36,9,9,0,0,0-2.11.82l-.29.17-.05,0-.22.15,0,0-.22.16h0l-.23.19a5.85,5.85,0,0,0,.95.65,9.46,9.46,0,0,0,2.09.81C392.16,239.69,396.27,238.5,399.68,239.52Z",
    style: {
      opacity: 0.03
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.7,260l0,1.33v.1c.1,2,3.07,3.58,6.73,3.58s6.62-1.59,6.73-3.56v-.12l.05-1.35c-.36,1.87-3.26,3.33-6.78,3.33S388.07,261.9,387.7,260Z",
    style: {
      fill: "#407BFF",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ice--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.7,247.71l1.42,2.32a.57.57,0,0,0,.46.27l2.94-.26c.15,0,.19-.16.09-.33l-1.42-2.31a.57.57,0,0,0-.46-.28l-2.94.27C395.64,247.4,395.6,247.55,395.7,247.71Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.89,250.73l1.42,2.32a.58.58,0,0,0,.21.2l.82-3a.7.7,0,0,1-.22-.2l-1.42-2.32c-.09-.15-.06-.29.07-.32a.41.41,0,0,0-.31.25l-.7,2.57A.78.78,0,0,0,394.89,250.73Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.52,253.25a.39.39,0,0,0,.11.06h.13l2.94-.26a.4.4,0,0,0,.33-.26l.7-2.56a.77.77,0,0,0-.1-.49c.07.15,0,.27-.11.29l-2.94.26a.39.39,0,0,1-.24-.07Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.53,256.44l2.4.81a.52.52,0,0,0,.49-.08l1.95-1.94c.09-.1,0-.23-.14-.28l-2.39-.81a.54.54,0,0,0-.49.07l-2,2C392.3,256.26,392.36,256.38,392.53,256.44Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.67,259.47l2.39.81a.54.54,0,0,0,.28,0l-1.14-3a.62.62,0,0,1-.27,0l-2.4-.81c-.16-.05-.22-.17-.14-.27a.36.36,0,0,0-.07.37l.95,2.63A.76.76,0,0,0,393.67,259.47Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.34,260.3a.35.35,0,0,0,.11,0h0l.06,0,0,0,1.95-1.94a.37.37,0,0,0,.09-.38l-.95-2.63a.75.75,0,0,0-.37-.29c.14.06.19.18.09.27l-1.94,1.94a.38.38,0,0,1-.22.1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.42,252.45l2.53-.64a.49.49,0,0,0,.3-.36l.52-2.45c0-.17,0-.29-.16-.25l-2.53.63a.49.49,0,0,0-.3.37l-.53,2.45C388.21,252.37,388.29,252.48,388.42,252.45Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.21,254.88l2.53-.63a.46.46,0,0,0,.19-.13l-1.8-2.44a.31.31,0,0,1-.18.13l-2.53.64c-.13,0-.2-.07-.18-.23a.81.81,0,0,0,.06.46l1.56,2.08A.35.35,0,0,0,390.21,254.88Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.93,254.12a.53.53,0,0,0,.06-.1l0,0a.14.14,0,0,0,0-.07s0,0,0,0l.53-2.45a.73.73,0,0,0-.05-.48L392,248.86a.34.34,0,0,0-.32-.12c.11,0,.17.1.13.26l-.52,2.45a.51.51,0,0,1-.12.23Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--orange--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.81,236.18a9.44,9.44,0,0,0,.68,1.26,2.9,2.9,0,0,1,.14-.48,3.7,3.7,0,0,1,1-1.4,5.73,5.73,0,0,1,.92-.71l.46.26v4.66h0l.1.05.27.11.13,0,.13.05h0l.12,0h0l.37.07h.14a2.52,2.52,0,0,0,.91-.07,1.71,1.71,0,0,0,.38-.13h0l1-.43a2.79,2.79,0,0,0,.62-.38l.09-.08.07-.07.08-.09.08-.08a0,0,0,0,1,0,0l.13-.18.08-.1.06-.1.06-.11.06-.11.06-.12a.54.54,0,0,1,0-.11.37.37,0,0,1,.05-.11.78.78,0,0,1,.05-.14.93.93,0,0,1,0-.13c0-.05,0-.1,0-.15a2.17,2.17,0,0,0,.07-.24c0-.09,0-.19.05-.28l0-.13a1,1,0,0,0,0-.16c0-.05,0-.1,0-.14s0-.1,0-.15V236a8,8,0,0,0-.7-3.3c-1.28-2.91-3.85-4.6-5.75-3.77l-1,.44C385,230.22,384.53,233.26,385.81,236.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,239.16v.61h0l.1.05.27.11.13,0,.13.05h0l.12,0h0l.37.07h.14a2.52,2.52,0,0,0,.91-.07,1.71,1.71,0,0,0,.38-.13h0l1-.43a2.79,2.79,0,0,0,.62-.38l.09-.08.07-.07.08-.09.08-.08a0,0,0,0,1,0,0l.13-.18.08-.1.06-.1.06-.11.06-.11.06-.12a.54.54,0,0,1,0-.11.37.37,0,0,1,.05-.11.78.78,0,0,1,.05-.14.93.93,0,0,1,0-.13c0-.05,0-.1,0-.15a2.17,2.17,0,0,0,.07-.24c0-.09,0-.19.05-.28l0-.13a1,1,0,0,0,0-.16c0-.05,0-.1,0-.14s0-.1,0-.15V236l-1,.59-.68.39-1.43.83L391,238l-1.31.75-.24.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.81,236.18a9.44,9.44,0,0,0,.68,1.26,2.9,2.9,0,0,1,.14-.48,3.7,3.7,0,0,1,1-1.4,5.73,5.73,0,0,1,.92-.71l.46.26v4.66h0l.1.05.27.11.13,0,.13.05h0l.12,0h0l.37.07h.14a2.52,2.52,0,0,0,.91-.07,1.71,1.71,0,0,0,.38-.13h0a3.61,3.61,0,0,0,1.79-3.33,7.89,7.89,0,0,0-.69-3.44c-1.28-2.92-3.85-4.61-5.76-3.78S384.53,233.26,385.81,236.18Z",
    style: {
      fill: "#fff",
      opacity: 0.9500000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.54,231.36c-.32-.44-.31-1,0-1.22l.21-.1L387,230c.36-.12.81.29.91.82l.54,3.09c0,.15-.1.21-.2.08Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--mascara--inject-21",
    d: "M386,233.28a1.32,1.32,0,0,1-.53-1.14c0-.13,0-.26.06-.39a3.57,3.57,0,0,1,.1-.35c.11-.33.47-.25.74.17l1.8,2.75c.08.13.05.28,0,.22Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.58,235.59c-.25.11-.63-.26-.77-.76,0-.1-.06-.19-.08-.29s-.05-.2-.07-.3c-.1-.49.12-.77.44-.58l1.77,1.05c.09.06.14.26.07.29Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.63,237a3.7,3.7,0,0,1,1-1.4l-1,.41C386.42,236.07,386.41,236.54,386.63,237Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,236.84v2.55l.09.05c.3.16.49-.12.41-.57a.31.31,0,0,0,0-.08Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--mascara--inject-21",
    d: "M391.28,238.3c.29.4.29,1,0,1.15a2.55,2.55,0,0,1-.33.17,2,2,0,0,1-.34.12c-.34.09-.74-.29-.84-.78l-.76-3.27c0-.15.1-.21.19-.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.8,235.5l2.37.9a1.07,1.07,0,0,1,.57,1.23,2,2,0,0,1-.1.26,2,2,0,0,1-.11.26c-.2.41-.72.39-1-.05l-1.78-2.34C389.6,235.63,389.67,235.45,389.8,235.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--mascara--inject-21",
    d: "M391.74,233.75c.34-.15.78.16.91.65a4.37,4.37,0,0,1,.12.52c0,.16.05.33.07.5.05.49-.28.81-.68.65l-2.66-1c-.12,0-.16-.25-.05-.29Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.36,231.8c.17-.41.67-.44,1-.05l.19.24c.06.08.13.16.19.25a.78.78,0,0,1-.16,1.16l-2,.88c-.11.05-.24-.11-.19-.23Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--mascara--inject-21",
    d: "M388.15,230.55c-.1-.53.22-.92.64-.81a3.81,3.81,0,0,1,.44.15l.44.19a1.07,1.07,0,0,1,.48,1.25L389,234.15c0,.13-.22.07-.25-.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.45
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.54,231.36c-.32-.44-.31-1,0-1.22l.21-.1L387,230c.36-.12.81.29.91.82l.54,3.09c0,.15-.1.21-.2.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--mascara--inject-21",
    d: "M386,233.28a1.32,1.32,0,0,1-.53-1.14c0-.13,0-.26.06-.39a3.57,3.57,0,0,1,.1-.35c.11-.33.47-.25.74.17l1.8,2.75c.08.13.05.28,0,.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.58,235.59c-.25.11-.63-.26-.77-.76,0-.1-.06-.19-.08-.29s-.05-.2-.07-.3c-.1-.49.12-.77.44-.58l1.77,1.05c.09.06.14.26.07.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.63,237a3.7,3.7,0,0,1,1-1.4l-1,.41C386.42,236.07,386.41,236.54,386.63,237Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,236.84v2.55l.09.05c.3.16.49-.12.41-.57a.31.31,0,0,0,0-.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--mascara--inject-21",
    d: "M391.28,238.3c.29.4.29,1,0,1.15a2.55,2.55,0,0,1-.33.17,2,2,0,0,1-.34.12c-.34.09-.74-.29-.84-.78l-.76-3.27c0-.15.1-.21.19-.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.8,235.5l2.37.9a1.07,1.07,0,0,1,.57,1.23,2,2,0,0,1-.1.26,2,2,0,0,1-.11.26c-.2.41-.72.39-1-.05l-1.78-2.34C389.6,235.63,389.67,235.45,389.8,235.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--mascara--inject-21",
    d: "M391.74,233.75c.34-.15.78.16.91.65a4.37,4.37,0,0,1,.12.52c0,.16.05.33.07.5.05.49-.28.81-.68.65l-2.66-1c-.12,0-.16-.25-.05-.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.36,231.8c.17-.41.67-.44,1-.05l.19.24c.06.08.13.16.19.25a.78.78,0,0,1-.16,1.16l-2,.88c-.11.05-.24-.11-.19-.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--mascara--inject-21",
    d: "M388.15,230.55c-.1-.53.22-.92.64-.81a3.81,3.81,0,0,1,.44.15l.44.19a1.07,1.07,0,0,1,.48,1.25L389,234.15c0,.13-.22.07-.25-.09Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M391.18,240.08a2.52,2.52,0,0,1-.91.07h-.14l-.37-.07h0l-.12,0h0l-.13-.05-.13,0-.27-.11-.1-.05h0v-4.66l2.56,4.85Z",
    style: {
      opacity: 0.07
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Umbrella--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.11,231.26a12.85,12.85,0,0,0-4.84-.46,40.63,40.63,0,0,0-6.38-2.22l1-2.59,1.45-3.84C407.1,224.48,409.89,226.67,412.11,231.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.11,231.26a12.85,12.85,0,0,0-4.84-.46,40.63,40.63,0,0,0-6.38-2.22l1-2.59,1.45-3.84C407.1,224.48,409.89,226.67,412.11,231.26Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.11,231.26a12.85,12.85,0,0,0-4.84-.46c.08-4-1.48-6.93-3.67-8.47A28.5,28.5,0,0,1,412.11,231.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.87,226l-.3.79a14.23,14.23,0,0,1,5.67,2.71,13.16,13.16,0,0,1,4.87,1.77S409,227.47,401.87,226Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.69,223.15a12.89,12.89,0,0,1,3.94,2.86,41.93,41.93,0,0,1,6.26,2.57l1-2.59,1.45-3.84C399,221.39,395.4,221.18,390.69,223.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.69,223.15a12.89,12.89,0,0,1,3.94,2.86,41.93,41.93,0,0,1,6.26,2.57l1-2.59,1.45-3.84C399,221.39,395.4,221.18,390.69,223.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.69,223.15a12.89,12.89,0,0,1,3.94,2.86c2.6-3,5.69-4.21,8.35-3.91A28.57,28.57,0,0,0,390.69,223.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.69,223.15a12.89,12.89,0,0,1,3.94,2.86c2.6-3,5.69-4.21,8.35-3.91A28.57,28.57,0,0,0,390.69,223.15Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.87,226l-.3.79a14.15,14.15,0,0,0-6.05-1.72,13.26,13.26,0,0,0-4.83-1.91S395.58,222.41,401.87,226Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.36,222.35l-9.79,29.07a.16.16,0,0,1-.1.08.4.4,0,0,1-.33-.12.12.12,0,0,1,0-.12l9.8-29.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.16,222.33l0,0,0,0,0,0c-.05,0,0-.06,0-.09a2,2,0,0,1,.1-.28c.08-.23.2-.53.32-.83.07-.15.13-.3.2-.44l.09-.2.08-.18.08-.15L404,220l.06-.1s0,0,0,.12,0,.07,0,.12a1.36,1.36,0,0,1,0,.17l0,.19a2.25,2.25,0,0,1,0,.22l-.12.46c-.09.32-.19.63-.26.86l-.1.28s0,.06-.07.06h-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.11,231.26a13.64,13.64,0,0,0-4.57-2.31,13.42,13.42,0,0,0-5.88-2.42l1.66-4.38A19.67,19.67,0,0,1,412.11,231.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.54,229a13.42,13.42,0,0,0-5.88-2.42l1.66-4.38a10.12,10.12,0,0,1,3.12,4.06A19.45,19.45,0,0,1,407.54,229Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.7,223.15a13.85,13.85,0,0,1,5,1.3,13.35,13.35,0,0,1,6,2.08l1.66-4.38A19.77,19.77,0,0,0,390.7,223.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.66,224.45a13.35,13.35,0,0,1,6,2.08l1.66-4.38a10.13,10.13,0,0,0-5,1A18,18,0,0,0,395.66,224.45Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M393.1,251.26l3-8.76.54-.08-3,9a.16.16,0,0,1-.1.08.4.4,0,0,1-.33-.12A.12.12,0,0,1,393.1,251.26Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.06,242.5l.16-.49.55-.08-.17.49Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M368,297c5.39,2.49,16.75-7.34,18.79-12.34s1.94-7.69-2-9.64S359.86,287.81,368,297Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.18,298c5.39,2.48,16.61-8.4,18.65-13.4s1.94-7.69-2-9.64S357,291.54,368.18,298Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.69,296.4c1.35.9,4.14,3.8-3.31,11.06s-11.08,13-16.76,10.63C333.89,314,351.53,291.59,363.69,296.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.12,362.58c-8.8-5.69-14.91-14.19-19.93-22.93-3.43-7.84-19.95-45.62-23-51-3.65-6.46-27.05-17.86-38.52-23.15-3.82-1.77-24.43-9.19-24.43-9.19L316.44,249c-1,7.7-1.88,13.68,1.15,21.26s10.53,11.78,21.58,17.33c9.14,4.59,34.87,11.18,37.58,12.18s5.43.67,6.57,5.67.8,7.3,6.12,13.55c6.82,8,18.81,18,23.07,26.67a14.92,14.92,0,0,1,.4,6.19c-1.19,7.86,5.65,7.81,10.12,12.36,2.44,2.48,4.06,5.18,7.32,6.72a22.21,22.21,0,0,0,9.5,2c2.94,0,7.4-1.15,9.39-3.56C451.88,366.19,447.06,364.49,444.12,362.58Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.07,302.22c-.57-6.36-8.94-9.16-15.67-12.88-5.71-3.16-34.52-17.46-34.52-17.46,2.37-5,.64-16.87.64-16.87l-19.8,8.09a28.62,28.62,0,0,0,1.87,7.2c3,7.59,10.53,11.78,21.58,17.33,9.14,4.59,34.87,11.18,37.58,12.18s5.43.67,6.57,5.67.8,7.3,6.12,13.55C384.75,312.34,385.39,305.86,385.07,302.22Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.06,384c-2,2.4-6.45,3.51-9.4,3.55a22.49,22.49,0,0,1-9.49-2c-3.27-1.56-4.88-4.27-7.31-6.73-4.48-4.56-11.33-4.5-10.15-12.36a14.57,14.57,0,0,0-.38-6.19c-.24-.45-.48-.91-.74-1.38-4.76-8.36-15.86-17.7-22.32-25.3-5.33-6.24-5-8.6-6.14-13.55s-3.84-4.64-6.56-5.67c-1.14-.43-6.32-1.83-12.64-3.61-3.35-.91-7-1.95-10.54-3a1.38,1.38,0,0,1-.26-.07c-12.55-4.58-21.46-11.72-24.94-16.84s-6.37-12.59-8-20.78l8.15-4.75,8.26-1.53,26.9-5a.12.12,0,0,0,0,.08c-.23,1.17-4.48,14.8-4.48,14.8a144.27,144.27,0,0,0,21.29,14.69c9.43,5.22,18.49,11,20.66,14.81,2.86,5.08,17.57,38.57,22.23,49.21.24.57.44,1,.63,1.47,5.16,8.69,11.49,16.87,20.14,22.76C415.46,378.33,420.71,380.76,418.06,384Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.09,296l.6.4s-5.81-1.41-13.41,5.31c-4,3.53-11.94,12-6.66,16.38,0,0-30.63-12.4-40.2-19.12s-12.39-15-15.2-28.11l47.33-15.79s19.17,6.68,31.24,11.78c14.11,6,18,8.15,18,8.15s-3.68-.39-9.57,5c-8.49,7.69-10.12,15.87-7.07,18.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.09,296l-25.54-14.72s4.55-5.3,6.14-11a13.69,13.69,0,0,1-2.85,10.42l15.92,9.74L368.18,298Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.61,202.75c8.29-1.28,12.1,0,18.86,11.15,5.46,9,14.17,25.34,14.17,25.34s28.17,8,32.38,8.15c3.61.14,6.13-1.29,9.78-.58,4.41.85,6.7,1.36,9,1.62.7.08.61,2.74-3.74,3a52.68,52.68,0,0,1-6.14,0l.35,9.84c-3.51-.53-6.62-2.17-10.55-2.55-3.53-.34-32.59-3.64-39.82-6.83-5-4.7-15.82-21.35-15.82-21.35Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.89,208.46l-7.33,2.15s1.08,24-3.05,26.74c2.58,23.28,13.19,45.56,13.19,45.56s12.79,1.37,30.06-7.45C335.9,267.73,335.52,255,335.52,255s-5.51-6.06-6.86-9c-3.59-7.87-2.36-21.85-4.19-27.25-4.1-12.16-11.86-16-11.86-16l-9.56,1.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.66,270.1c-6.12-4.16-11.16-25.13-11.31-29.67s2.61-19.15.67-23.76l-4.34-.44c0,7.26-.33,19.21-3.17,21.12,2.58,23.28,13.19,45.56,13.19,45.56s12.79,1.37,30.06-7.45a29.29,29.29,0,0,0,9.83-7.79C322.22,273.06,301.59,274.14,295.66,270.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.09,169.22c1.1-1.48,3.15-2.66,4.93-1.46a2.94,2.94,0,0,1,.69.76,6.16,6.16,0,0,1,.33.55c.85,1.57.68,3.14,1,4.82l.81,4.24,1,5.42,1.11-.22L286.2,191l.76,6.43h-.65a5.37,5.37,0,0,1-3.83-2.63c-1.24-1.79-2.74-3.41-3.91-5.29a48.27,48.27,0,0,1-3.21-6,20.52,20.52,0,0,1-2.14-8.4,10.28,10.28,0,0,1,1.85-5.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.13,162.2a.52.52,0,0,1,.27,0,.5.5,0,0,1,.29.18,7.79,7.79,0,0,1,2.16,4.38,7.16,7.16,0,0,1-.34,3.73,5,5,0,0,1-2.51,2.72,2,2,0,0,1-1.08.21,2.25,2.25,0,0,1-1.12-.56,10.45,10.45,0,0,1-1.5-1.62,5.19,5.19,0,0,1-1.45-3.49,1.29,1.29,0,0,1,.19-.61,2.19,2.19,0,0,1,.42-.38,22.21,22.21,0,0,0,1.81-1.68c.54-.49,1.07-1,1.58-1.51S313.52,162.48,314.13,162.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.32,184.61c-.78.57-2.12-.91-3.24-1.88s-4.61-2.11-5.94,1.56,1.88,8,4.39,9.11a4.18,4.18,0,0,0,5.22-1.37l1.51,16.35A17.75,17.75,0,0,0,300,214.63c8.14.31,5.84-6.15,2.89-9.14l-.5-5a28.32,28.32,0,0,0,6.14-.28c3.28-.84,6.12-1.89,6.68-7.53.54-5.48.67-10.57-1.45-22.46-2.23-12.45-18-10.4-25.34-4.7S285.32,184.61,285.32,184.61Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.46,186c-.42.05-2.26-2.43-3.38-3.27-.47-.35-.58-1.17-.67-1.69-.33-1.8-.17-3.6-.63-5.36a21.41,21.41,0,0,0-2.36-4.68,9.47,9.47,0,0,1-1.34-5.26,8.1,8.1,0,0,1,2.81-5.18,14.84,14.84,0,0,1,5.27-2.85c4.12-1.37,8.5-1.69,12.77-2.5s8.61-2.22,11.68-5.29c.24-.24.56-.51.87-.39a.64.64,0,0,1,.27.22c1.39,1.56.68,4,1.08,6.05a6.1,6.1,0,0,0,4.13-1.52c1.22.75,1.42,2.44,1.35,3.87a13,13,0,0,1-2.14,6.81c-1.29,1.85-4.12,2.11-6.15,1.57a.71.71,0,0,0-.38-.05.82.82,0,0,0-.45.43c-1.49,2.27-4.4,3.21-7.11,3.28s-5.4-.56-8.12-.69a7.2,7.2,0,0,0-3.09.42c-1.2.52-1.49,1.35-2,2.47a8.8,8.8,0,0,0-.65,1.63,8.23,8.23,0,0,0-.17,1.79C287,177.11,287.68,185.74,285.46,186Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.34,200.51s-7.59-.77-10.32-1.9a8.61,8.61,0,0,1-3.94-3.21,11.77,11.77,0,0,0,2.45,4c2.14,2.24,12,3.09,12,3.09Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.07,180.94a1.5,1.5,0,1,1-3,.28,1.51,1.51,0,0,1,1.34-1.69A1.53,1.53,0,0,1,300.07,180.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.61,174.24l-3,2.07a1.93,1.93,0,0,1,.49-2.62A1.8,1.8,0,0,1,296.61,174.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.14,190.81l3.9,1a2,2,0,0,1-2.44,1.5A2.11,2.11,0,0,1,300.14,190.81Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.58,174.15l-3.12-2a1.77,1.77,0,0,1,2.49-.63A1.93,1.93,0,0,1,312.58,174.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.05,179.13a1.52,1.52,0,0,1-1.34,1.69,1.54,1.54,0,0,1-1.64-1.41,1.5,1.5,0,1,1,3-.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.59,180.05c-.27-2,2.14-2.87,7.09-3.47,3-.37,15.84-2.05,15.84-2.05h0c4-.23,4.67.93,4.85,3.25.32,4,.05,6.66-4.35,7.2-3,.37-5.76-.86-6.19-4.27l-.14-1.06a1.43,1.43,0,0,0-1.6-1.24h0a1.43,1.43,0,0,0-1.23,1.6l.12,1a5.65,5.65,0,0,1-.15,2.31c-.52,2.12-2.68,5.61-7.92,5S290,182.81,289.59,180.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.36 178.95 305.72 187.87 310.96 185.5 304.36 178.95",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.96 333.08 258.34 334.38 275.17 266.34 271.8 260.51 268.44 262.45 251.6 330.49 255.96 333.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.44 262.45 271.8 268.28 255.96 333.08 251.6 330.49 268.44 262.45",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.8,324.74c-10.08.21-80.6,1.62-90.68,1.84a5.75,5.75,0,0,0-2.33.64l-1.21.7c-.6.35-.6.9,0,1.24l11.16,6a5.33,5.33,0,0,0,2.32.6l77.39-1.62a5.68,5.68,0,0,0,2.32-.65l1.21-.7a2.37,2.37,0,0,0,1.08-1.86v-5A1.21,1.21,0,0,0,336.8,324.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.68,332.85v-5a1.2,1.2,0,0,0-1.24-1.22l-90.7,1.84c-.69,0-.76.3-.17.64l11.16,6a5.33,5.33,0,0,0,2.32.6l77.39-1.62A1.27,1.27,0,0,0,334.68,332.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.05,326v4.95a2.37,2.37,0,0,1-1.08,1.87l-1.21.7a5.88,5.88,0,0,1-2.32.65,1.27,1.27,0,0,0,1.24-1.27v-5a1.2,1.2,0,0,0-.48-1l3.37-1.94A1.18,1.18,0,0,1,338.05,326Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.6,376.52l-8-4.59a4.72,4.72,0,0,1-1.61-1.74L231.93,195.54a1.38,1.38,0,0,1,.55-1.75l1.21-.7a2.39,2.39,0,0,1,2.15,0l7.95,4.59a4.56,4.56,0,0,1,1.61,1.74l83.11,174.66a1.37,1.37,0,0,1-.54,1.74l-1.22.7A2.39,2.39,0,0,1,324.6,376.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.79,198.92l-1.21.7a1.37,1.37,0,0,0-.54,1.75L325.14,376a1.13,1.13,0,0,0,1.61.5l1.22-.7a1.37,1.37,0,0,0,.54-1.74L245.4,199.42A1.13,1.13,0,0,0,243.79,198.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.32,199.28a1.14,1.14,0,0,0-1.53-.36l-1.21.71a1.3,1.3,0,0,0-.63.87l-10.1-5.83a1.35,1.35,0,0,1,.63-.88l1.21-.7a2.39,2.39,0,0,1,2.15,0l7.95,4.59A4.79,4.79,0,0,1,245.32,199.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,305.22v.06s0,0,0-.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,305.29v3.86h0a2.3,2.3,0,0,1-1.33,1.88,7.7,7.7,0,0,1-7-.14L280,288.53a1,1,0,0,1-.59-.82v-3.88h0a1,1,0,0,0,.58.83L318.72,307a7.7,7.7,0,0,0,7,.14A2.3,2.3,0,0,0,327,305.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.68,307.17a7.7,7.7,0,0,1-7-.14L280,284.66a.87.87,0,0,1,0-1.66l3.86-2.23a3.22,3.22,0,0,1,2.87,0l38.75,22.38a2.63,2.63,0,0,1,1.55,2.14A2.3,2.3,0,0,1,325.68,307.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.26,210.28c-7.61,1.84-8,2.79-14.91,15.31-2.11,3.87-6.94,11.73-8.55,15.24-6.76-5.58-21.11-17.8-22.42-21.3-.15-.41-.34-1.39-.5-2.14a20.55,20.55,0,0,0-2-5.32,20.9,20.9,0,0,1-.93-2.25,1.15,1.15,0,0,0-.29-.57.8.8,0,0,0-.58-.17,1.51,1.51,0,0,0-1.2,1c-.49,1.24.06,2.67.24,3.91a1.59,1.59,0,0,1-.71,1.65,2.16,2.16,0,0,1-1.21.37c-1.69,0-2.54-1.71-2.82-2.59a5,5,0,0,1,.35-3.49,1.8,1.8,0,0,1,1.2-1.1c.8-.17,1.36.53,2.14.54a1.05,1.05,0,0,0,1.1-.83,1.18,1.18,0,0,0-.14-.6,3.82,3.82,0,0,0-4-2,5.81,5.81,0,0,0-3.84,2.59,3.27,3.27,0,0,0-.6,2.67c-1.49-2.06-2.46-3.28-3.91-5.61-1.57-2.54-3.4-5.63-4.54-3.3-1,2,5.7,11.58,5.7,11.58a34.71,34.71,0,0,1-5.15-6.09c-1.27-1.82-2.11-3.86-3.54-2.78-2.28,1.72,6,11.3,6,11.3-3.37-2.3-6.48-7.54-7.76-6.4s.08,3.23,4,8c2.92,3.51,6.21,7.38,10.36,9.41a21.66,21.66,0,0,1,3.45,2.11c4.65,4,8.65,9,12.77,13.52,5.79,6.34,16.84,17.48,21.12,16.66s9.69-10,12.86-14.74c5.62-8.44,6.19-9.18,6.19-9.18C286.44,227.06,287.09,212.68,281.26,210.28Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.8,240.83s3.42,3.16,4,5.15c0,0,.25-2.55-3.22-6.74Z",
    style: {
      fill: "#f28f8f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.67,347.54s-7.64-4.93-.31-25.22c8.91-24.67,33.2-29.4,49.63-26.91a47.33,47.33,0,0,0-13.4,10L221.83,309l14.31.34a24.45,24.45,0,0,1-6.32,8.53s-9.8.65-16,3l12.31,1a13.53,13.53,0,0,1-3.21,6.24C220.16,331.45,213.16,341.72,202.67,347.54Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.67,347.54s-7.64-4.93-.31-25.22c8.91-24.67,33.2-29.4,49.63-26.91a47.33,47.33,0,0,0-13.4,10L221.83,309l14.31.34a24.45,24.45,0,0,1-6.32,8.53s-9.8.65-16,3l12.31,1a13.53,13.53,0,0,1-3.21,6.24C220.16,331.45,213.16,341.72,202.67,347.54Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.39,347.06s3.71-13.14,19.74-18.84,38.25,5.92,45.87,13.7c0,0-9.14-1.43-23.47,2.84L232.89,338l5.91,8.33L229,348.62l-11.49-7.47,6.25,8.59S211.37,353.35,202.39,347.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.39,347.06s3.71-13.14,19.74-18.84,38.25,5.92,45.87,13.7a197.61,197.61,0,0,0-23.88,4.14l-11.23-8,5.91,8.33L229,348.62l-11.49-7.47,6.25,8.59S211.37,353.35,202.39,347.06Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.33,345.31a60.78,60.78,0,0,1-12.93-7.68,51.65,51.65,0,0,1-10.68-12.78l13,.87L89,321.64a59,59,0,0,1-4.73-10.89l13.76,1.56L83.41,306c-2.65-4.23-5.43-13.83-11.13-18.45,0,0,12.17,2,27.24,15.05C114,315.24,116.93,336.84,114.33,345.31Z",
    style: {
      fill: "#407BFF"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glass--inject-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--glass--inject-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--glass--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205,215.85l-4.14,120.49v0a14.21,14.21,0,0,1-1.26,5.25c-1.8,4-5.51,7.84-11.15,11-16.54,9.25-43.38,9.25-59.93,0-5.63-3.16-9.34-7-11.14-11a14.36,14.36,0,0,1-1.22-4.58V337a9,9,0,0,1,0-1.37v-.07L112,215.93a18.79,18.79,0,0,1-3.49-9.94l5,145.91,0,1.48c.5,6.23,4.87,12.39,13.12,17.16,17.57,10.14,46.05,10.14,63.61,0,8.57-5,13-11.41,13.16-17.89v-.47l5-146.19A18.63,18.63,0,0,1,205,215.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,215.85l-4.14,120.49v0a14.21,14.21,0,0,1-1.26,5.25c-1.8,4-5.51,7.84-11.15,11-16.54,9.25-43.38,9.25-59.93,0-5.63-3.16-9.34-7-11.14-11a14.36,14.36,0,0,1-1.22-4.58V337a9,9,0,0,1,0-1.37v-.07L112,215.93a18.79,18.79,0,0,1-3.49-9.94l5,145.91,0,1.48c.5,6.23,4.87,12.39,13.12,17.16,17.57,10.14,46.05,10.14,63.61,0,8.57-5,13-11.41,13.16-17.89v-.47l5-146.19A18.63,18.63,0,0,1,205,215.85Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.83,225.69c-19.51,11.27-51.16,11.27-70.67,0A33.49,33.49,0,0,1,112,215.93l4.09,119.63v.07l0,1.37v.05a14.36,14.36,0,0,0,1.22,4.58c1.8,4,5.51,7.84,11.14,11,16.55,9.25,43.39,9.25,59.93,0,5.64-3.16,9.35-7,11.15-11a14.21,14.21,0,0,0,1.26-5.25v0L205,215.85A33.5,33.5,0,0,1,193.83,225.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.83,225.69c-19.51,11.27-51.16,11.27-70.67,0A33.49,33.49,0,0,1,112,215.93l4.09,119.63v.07l0,1.37v.05a14.36,14.36,0,0,0,1.22,4.58c1.8,4,5.51,7.84,11.14,11,16.55,9.25,43.39,9.25,59.93,0,5.64-3.16,9.35-7,11.15-11a14.21,14.21,0,0,0,1.26-5.25v0L205,215.85A33.5,33.5,0,0,1,193.83,225.69Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.14,336.71c.37,5.78,4.5,11.5,12.39,15.92,16.55,9.26,43.38,9.26,59.93,0,7.89-4.42,12-10.14,12.39-15.92l3.5-102.86c.39-6.78-4.09-13.63-13.41-18.8-17.92-9.94-47-9.94-64.89,0-9.32,5.17-13.79,12-13.41,18.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.5,
    cy: 335.86,
    rx: 42.38,
    ry: 23.71,
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.14,336.71c.37,5.78,4.5,11.5,12.39,15.92,16.55,9.26,43.38,9.26,59.93,0,7.89-4.42,12-10.14,12.39-15.92l3.5-102.86c.39-6.78-4.09-13.63-13.41-18.8-17.92-9.94-47-9.94-64.89,0-9.32,5.17-13.79,12-13.41,18.8Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.5,
    cy: 233.04,
    rx: 45.88,
    ry: 25.45,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.93,251.05c-15.52,8.61-39.41,9.75-57.17,3.43,24.74,4.31,48-7.22,45.94-22.08,0-.31-.1-.62-.17-.94a59.28,59.28,0,0,0,14.3-5.77,42,42,0,0,0,5.75-4C208.12,231.24,205.24,243.11,190.93,251.05Z",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.83,184.89c-19.51-11.27-51.16-11.27-70.67,0-10.07,5.81-14.94,13.48-14.61,21.1a18.79,18.79,0,0,0,3.49,9.94,33.49,33.49,0,0,0,11.12,9.76c19.51,11.27,51.16,11.27,70.67,0A33.5,33.5,0,0,0,205,215.85a18.63,18.63,0,0,0,3.44-9.86v-.19C208.69,198.24,203.81,190.65,193.83,184.89Zm-2.23,38.76c-18.29,10.14-47.92,10.14-66.2,0s-18.28-26.58,0-36.72,47.91-10.15,66.2,0S209.87,213.51,191.6,223.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.83,184.89c-19.51-11.27-51.16-11.27-70.67,0-10.07,5.81-14.94,13.48-14.61,21.1a18.79,18.79,0,0,0,3.49,9.94,33.49,33.49,0,0,0,11.12,9.76c19.51,11.27,51.16,11.27,70.67,0A33.5,33.5,0,0,0,205,215.85a18.63,18.63,0,0,0,3.44-9.86v-.19C208.69,198.24,203.81,190.65,193.83,184.89Zm-2.23,38.76c-18.29,10.14-47.92,10.14-66.2,0s-18.28-26.58,0-36.72,47.91-10.15,66.2,0S209.87,213.51,191.6,223.65Z",
    style: {
      fill: "#fff",
      opacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.6,223.65c-18.29,10.14-47.92,10.14-66.2,0s-18.28-26.58,0-36.72,47.91-10.15,66.2,0S209.87,213.51,191.6,223.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.6,223.65c-18.29,10.14-47.92,10.14-66.2,0s-18.28-26.58,0-36.72,47.91-10.15,66.2,0S209.87,213.51,191.6,223.65Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.49,219.65a37.37,37.37,0,0,0,5.91,4c18.28,10.14,47.91,10.14,66.2,0a38.31,38.31,0,0,0,5.91-4,35.84,35.84,0,0,0-6.57-4.6c-17.92-9.94-47-9.94-64.89,0A35.41,35.41,0,0,0,119.49,219.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.49,219.65a37.37,37.37,0,0,0,5.91,4c18.28,10.14,47.91,10.14,66.2,0a38.31,38.31,0,0,0,5.91-4,35.84,35.84,0,0,0-6.57-4.6c-17.92-9.94-47-9.94-64.89,0A35.41,35.41,0,0,0,119.49,219.65Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.06,215.05c.55-.32,1.13-.62,1.7-.91l.09,0c.9-.44,1.83-.87,2.79-1.27a65.73,65.73,0,0,1,16.62-4.46c1.58-.22,3.18-.4,4.8-.52,1.37-.12,2.76-.19,4.15-.22.76,0,1.52,0,2.29,0,1.47,0,2.93,0,4.4.12A75.84,75.84,0,0,1,177.82,210a55.63,55.63,0,0,1,13.11,5.1c.62.34,1.21.69,1.78,1l.33.21c.47.31.93.6,1.37.91l.23.16c.48.35,1,.69,1.39,1l.08.07c.49.38.95.77,1.39,1.17a37.72,37.72,0,0,1-5.9,4,56.07,56.07,0,0,1-13,5.09C172.88,216.07,147.28,208.71,126.06,215.05Z",
    style: {
      opacity: 0.03
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.65,342.73l-.28,8.31v.6c-.57,12.35-19.11,22.27-41.88,22.27s-41.19-9.86-41.87-22.16l0-.73-.26-8.38c2.25,11.62,20.28,20.68,42.18,20.68S198.33,354.31,200.65,342.73Z",
    style: {
      fill: "#407BFF",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--ice--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.81,266,142,280.43a3.48,3.48,0,0,1-2.84,1.7l-18.3-1.65c-.93-.09-1.17-1-.54-2l8.84-14.4a3.51,3.51,0,0,1,2.84-1.71l18.3,1.66C151.21,264.1,151.45,265,150.81,266Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91,284.83l-8.83,14.4a4.07,4.07,0,0,1-1.31,1.27l-5.1-18.8a4.07,4.07,0,0,0,1.31-1.27L150.82,266c.6-1,.41-1.83-.4-2a2.42,2.42,0,0,1,1.92,1.55l4.35,16A5,5,0,0,1,155.91,284.83Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77,300.5a3.36,3.36,0,0,1-.73.33l-.16.05a2,2,0,0,1-.41.06h-.23l-18.31-1.65a2.45,2.45,0,0,1-2.06-1.57l-4.34-16a4.8,4.8,0,0,1,.63-3c-.45.92-.18,1.68.68,1.77l18.3,1.66a2.65,2.65,0,0,0,1.53-.44Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.54,320.35l-14.91,5a3.27,3.27,0,0,1-3-.48l-12.1-12.1c-.62-.62-.25-1.4.82-1.76l14.91-5a3.27,3.27,0,0,1,3,.47l12.1,12.11C172,319.2,171.61,320,170.54,320.35Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.49,339.21l-14.92,5a3.59,3.59,0,0,1-1.69.13l7.06-18.87a3.58,3.58,0,0,0,1.69-.12l14.92-5c1-.34,1.39-1.07.9-1.66a2.26,2.26,0,0,1,.45,2.26L166,337.32A4.7,4.7,0,0,1,163.49,339.21Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.88,344.37a2.73,2.73,0,0,1-.72-.2l-.14-.06a2.63,2.63,0,0,1-.33-.2,1.07,1.07,0,0,1-.16-.14l-12.11-12.1a2.29,2.29,0,0,1-.54-2.36l5.91-16.38a4.43,4.43,0,0,1,2.26-1.79c-.88.38-1.14,1.09-.57,1.66l12.1,12.11a2.48,2.48,0,0,0,1.36.59Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.18,295.48l-15.75-3.94a3.11,3.11,0,0,1-1.87-2.28L175.28,274c-.22-1.05.24-1.75,1-1.55l15.75,3.95a3.11,3.11,0,0,1,1.87,2.27l3.28,15.26C197.45,295,197,295.68,196.18,295.48Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,310.65l-15.74-3.95a2.22,2.22,0,0,1-1.15-.82l11.18-15.16a2.3,2.3,0,0,0,1.15.82l15.75,3.94c.76.19,1.22-.42,1.07-1.38a4.48,4.48,0,0,1-.36,2.84l-9.71,13A2.17,2.17,0,0,1,185,310.65Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.1,305.88a3,3,0,0,1-.41-.63l-.08-.15a3.61,3.61,0,0,1-.16-.42c0-.08,0-.17-.07-.26l-3.28-15.26a4.62,4.62,0,0,1,.32-3l9.72-13a2.08,2.08,0,0,1,2-.77c-.68-.05-1.06.61-.85,1.59l3.28,15.25a3.57,3.57,0,0,0,.72,1.46Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--orange--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.4,194.23a55,55,0,0,1-4.23,7.87,18.33,18.33,0,0,0-.86-3,24,24,0,0,0-6.05-8.74,37.53,37.53,0,0,0-5.71-4.41l-2.86,1.65v29l-.09,0c-.21.12-.42.21-.64.31-.54.26-1.09.48-1.63.68l-.81.29c-.27.1-.54.18-.81.26h0l-.77.22a.31.31,0,0,1-.13,0,16.84,16.84,0,0,1-2.29.45l-.1,0-.76.07a16.64,16.64,0,0,1-5.69-.43,14.19,14.19,0,0,1-2.35-.81l-.24-.1c-1.34-.6-5.06-2.21-6.06-2.66a15.91,15.91,0,0,1-3.81-2.37c-.19-.16-.38-.32-.57-.5l-.45-.43c-.17-.18-.35-.35-.51-.53s-.32-.35-.47-.53l-.13-.15c-.28-.34-.56-.7-.83-1.07l-.46-.67c-.13-.2-.26-.4-.38-.61s-.27-.44-.39-.67-.26-.46-.38-.7-.23-.47-.34-.71-.23-.49-.34-.73-.19-.45-.28-.69l-.32-.84c-.08-.26-.18-.52-.26-.78s-.2-.63-.28-.94c-.14-.51-.27-1-.4-1.54s-.23-1.14-.33-1.73c-.05-.27-.09-.55-.13-.83s-.09-.64-.13-1-.07-.61-.09-.91-.05-.61-.07-.92l0-.94,0-.95a49.73,49.73,0,0,1,4.37-20.54c7.93-18.16,23.95-28.68,35.79-23.51l6.31,2.76C217.17,157.15,220.34,176.07,212.4,194.23Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,212.8v3.81l-.09,0c-.21.12-.42.21-.64.31-.54.25-1.09.48-1.63.68l-.81.29c-.27.1-.54.18-.81.26h0l-.77.22a.31.31,0,0,1-.13,0,21,21,0,0,1-2.29.45l-.1,0-.76.07a16.64,16.64,0,0,1-5.69-.43,14.19,14.19,0,0,1-2.35-.81l-.24-.1c-1.34-.6-5.06-2.21-6.06-2.66a15.91,15.91,0,0,1-3.81-2.37c-.19-.16-.38-.32-.57-.5l-.45-.43c-.17-.18-.35-.35-.51-.53s-.32-.35-.47-.53l-.13-.15c-.28-.34-.56-.7-.83-1.07l-.46-.67c-.13-.2-.26-.4-.38-.61s-.27-.44-.39-.67-.26-.46-.38-.7-.23-.47-.34-.71-.23-.49-.34-.73-.19-.45-.28-.69l-.32-.84c-.08-.26-.18-.52-.26-.78s-.2-.63-.28-.94c-.14-.51-.27-1-.4-1.54s-.23-1.14-.33-1.73c-.05-.27-.09-.55-.13-.83s-.09-.64-.13-1-.07-.61-.09-.91-.05-.61-.07-.92l0-.94,0-.95,6.32,3.65,4.24,2.45,8.95,5.16,1.56.9,8.14,4.71,1.48.85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.4,194.23a55,55,0,0,1-4.23,7.87,18.33,18.33,0,0,0-.86-3,24,24,0,0,0-6.05-8.74,37.53,37.53,0,0,0-5.71-4.41l-2.86,1.65v29l-.09,0c-.21.12-.42.21-.64.31-.54.26-1.09.48-1.63.68l-.81.29c-.27.1-.54.18-.81.26h0l-.77.22a.31.31,0,0,1-.13,0,16.84,16.84,0,0,1-2.29.45l-.1,0-.76.07a16.64,16.64,0,0,1-5.69-.43,14.19,14.19,0,0,1-2.35-.81l-.24-.1c-6.89-3.16-10.78-11-11.17-20.71a49.39,49.39,0,0,1,4.34-21.43c7.94-18.16,24-28.68,35.81-23.51S220.34,176.07,212.4,194.23Z",
    style: {
      fill: "#fff",
      opacity: 0.9500000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9500000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.9,151.53h0a15,15,0,0,1,6.09,1.25c5.45,2.38,9.15,7.92,10.44,15.6s-.05,16.87-3.82,25.5a55,55,0,0,1-3.1,6l-.63.95c.11.41.2.83.29,1.25a55,55,0,0,0,4.23-7.87c7.94-18.16,4.77-37.08-7.06-42.25a16,16,0,0,0-6.44-1.32h0c-10.69,0-22.8,9.8-29.37,24.83a49.39,49.39,0,0,0-4.34,21.43c.39,9.66,4.28,17.55,11.17,20.71l.24.1a14.19,14.19,0,0,0,2.35.81,16.43,16.43,0,0,0,4.09.51c.53,0,1.06,0,1.6-.08l.76-.07.1,0a16.84,16.84,0,0,0,2.29-.45.31.31,0,0,0,.13,0l.77-.22h0c.27-.08.54-.16.81-.26l.81-.29c.54-.2,1.09-.42,1.63-.68.22-.1.43-.19.64-.31l.09,0v-.94c-.08,0-1,.46-1.1.49a15.64,15.64,0,0,1-1.53.65l-.35.13-.47.16c-.22.08-.43.15-.65.21h0l-.12,0-.74.21h0l-.11,0a17.51,17.51,0,0,1-2.18.43h-.12l-.34,0-.37,0c-.51,0-1,.07-1.52.07a15.62,15.62,0,0,1-3.88-.48,14.8,14.8,0,0,1-2.21-.76l-.12-.06-.1,0c-6.39-2.93-10.28-10.2-10.67-20a48.44,48.44,0,0,1,4.27-21c6.25-14.31,18-24.31,28.57-24.31m9,49.32",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35000000000000003
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.9,151.53h0a15,15,0,0,1,6.09,1.25c5.45,2.38,9.15,7.92,10.44,15.6s-.05,16.87-3.82,25.5a55,55,0,0,1-3.1,6l-.63.95c.11.41.2.83.29,1.25a55,55,0,0,0,4.23-7.87c7.94-18.16,4.77-37.08-7.06-42.25a16,16,0,0,0-6.44-1.32h0c-10.69,0-22.8,9.8-29.37,24.83a49.39,49.39,0,0,0-4.34,21.43c.39,9.66,4.28,17.55,11.17,20.71l.24.1a14.19,14.19,0,0,0,2.35.81,16.43,16.43,0,0,0,4.09.51c.53,0,1.06,0,1.6-.08l.76-.07.1,0a16.84,16.84,0,0,0,2.29-.45.31.31,0,0,0,.13,0l.77-.22h0c.27-.08.54-.16.81-.26l.81-.29c.54-.2,1.09-.42,1.63-.68.22-.1.43-.19.64-.31l.09,0v-.94c-.08,0-1,.46-1.1.49a15.64,15.64,0,0,1-1.53.65l-.35.13-.47.16c-.22.08-.43.15-.65.21h0l-.12,0-.74.21h0l-.11,0a17.51,17.51,0,0,1-2.18.43h-.12l-.34,0-.37,0c-.51,0-1,.07-1.52.07a15.62,15.62,0,0,1-3.88-.48,14.8,14.8,0,0,1-2.21-.76l-.12-.06-.1,0c-6.39-2.93-10.28-10.2-10.67-20a48.44,48.44,0,0,1,4.27-21c6.25-14.31,18-24.31,28.57-24.31m9,49.32",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M207.34,165c1.9-2.6,1.83-6.21-.14-7.3-.39-.21-.8-.41-1.21-.59a13.08,13.08,0,0,0-1.26-.49c-2.14-.71-4.83,1.7-5.45,4.86l-3.23,18.37c-.19.94.64,1.3,1.2.53Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--mascara--inject-21",
    d: "M210.54,176.33a7.9,7.9,0,0,0,3.16-6.72c-.09-.79-.22-1.56-.38-2.3a17.85,17.85,0,0,0-.56-2.1c-.64-2-2.77-1.47-4.38,1l-10.7,16.33c-.49.75-.3,1.63.28,1.29Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.58,190.58c1.56.68,3.95-1.64,4.83-4.72.18-.61.34-1.23.5-1.85s.29-1.23.42-1.83c.65-3-.72-4.82-2.75-3.61l-11,6.54c-.6.36-.91,1.58-.44,1.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.31,199.09a24,24,0,0,0-6.05-8.74l5.9,2.58C208.6,193.56,208.66,196.49,207.31,199.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,198.35v15.89c-.18.11-.37.2-.55.3-1.92,1-3.11-.76-2.58-3.55,0-.16.06-.31.1-.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--mascara--inject-21",
    d: "M178.38,207.46c-1.81,2.49-1.85,6,0,7.12a13.93,13.93,0,0,0,2,1.07,15,15,0,0,0,2.16.76c2.08.56,4.62-1.84,5.21-4.85l4.74-20.39c.19-.93-.63-1.28-1.18-.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.54,190l-14.71,5.59a6.54,6.54,0,0,0-3.55,7.61c.19.57.39,1.12.61,1.67s.45,1.07.7,1.59c1.24,2.57,4.46,2.43,6.51-.28l11.07-14.61C188.78,190.81,188.34,189.73,187.54,190Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--mascara--inject-21",
    d: "M175.51,179.1c-2.11-.93-4.9,1-5.7,4-.28,1.07-.52,2.15-.71,3.23s-.34,2.11-.45,3.15c-.3,3,1.77,5,4.25,4.06l16.54-6.41c.76-.3,1-1.55.33-1.84Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.11,167c-1.11-2.59-4.21-2.77-6.29-.35-.41.48-.82,1-1.21,1.49s-.78,1-1.15,1.56c-1.85,2.65-1.37,6.23.95,7.25L189,182.44c.69.3,1.48-.72,1.15-1.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--mascara--inject-21",
    d: "M197.85,159.2c.59-3.27-1.36-5.72-4-5a26.93,26.93,0,0,0-2.72.89,29.64,29.64,0,0,0-2.71,1.22,6.67,6.67,0,0,0-3,7.74l7,17.6c.32.8,1.4.38,1.58-.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.45
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.34,165c1.9-2.6,1.83-6.21-.14-7.3-.39-.21-.8-.41-1.21-.59a13.08,13.08,0,0,0-1.26-.49c-2.14-.71-4.83,1.7-5.45,4.86l-3.23,18.37c-.19.94.64,1.3,1.2.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--mascara--inject-21",
    d: "M210.54,176.33a7.9,7.9,0,0,0,3.16-6.72c-.09-.79-.22-1.56-.38-2.3a17.85,17.85,0,0,0-.56-2.1c-.64-2-2.77-1.47-4.38,1l-10.7,16.33c-.49.75-.3,1.63.28,1.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.58,190.58c1.56.68,3.95-1.64,4.83-4.72.18-.61.34-1.23.5-1.85s.29-1.23.42-1.83c.65-3-.72-4.82-2.75-3.61l-11,6.54c-.6.36-.91,1.58-.44,1.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.31,199.09a24,24,0,0,0-6.05-8.74l5.9,2.58C208.6,193.56,208.66,196.49,207.31,199.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,198.35v15.89c-.18.11-.37.2-.55.3-1.92,1-3.11-.76-2.58-3.55,0-.16.06-.31.1-.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--mascara--inject-21",
    d: "M178.38,207.46c-1.81,2.49-1.85,6,0,7.12a13.93,13.93,0,0,0,2,1.07,15,15,0,0,0,2.16.76c2.08.56,4.62-1.84,5.21-4.85l4.74-20.39c.19-.93-.63-1.28-1.18-.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.54,190l-14.71,5.59a6.54,6.54,0,0,0-3.55,7.61c.19.57.39,1.12.61,1.67s.45,1.07.7,1.59c1.24,2.57,4.46,2.43,6.51-.28l11.07-14.61C188.78,190.81,188.34,189.73,187.54,190Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--mascara--inject-21",
    d: "M175.51,179.1c-2.11-.93-4.9,1-5.7,4-.28,1.07-.52,2.15-.71,3.23s-.34,2.11-.45,3.15c-.3,3,1.77,5,4.25,4.06l16.54-6.41c.76-.3,1-1.55.33-1.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.11,167c-1.11-2.59-4.21-2.77-6.29-.35-.41.48-.82,1-1.21,1.49s-.78,1-1.15,1.56c-1.85,2.65-1.37,6.23.95,7.25L189,182.44c.69.3,1.48-.72,1.15-1.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--mascara--inject-21",
    d: "M197.85,159.2c.59-3.27-1.36-5.72-4-5a26.93,26.93,0,0,0-2.72.89,29.64,29.64,0,0,0-2.71,1.22,6.67,6.67,0,0,0-3,7.74l7,17.6c.32.8,1.4.38,1.58-.62Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179,218.54a16.64,16.64,0,0,0,5.69.43l.76-.07.1,0a16.84,16.84,0,0,0,2.29-.45.31.31,0,0,0,.13,0l.77-.22h0c.27-.08.54-.16.81-.26l.81-.29c.54-.2,1.09-.42,1.63-.68.22-.1.43-.19.64-.31l.09,0v-29L176.77,217.8A15.12,15.12,0,0,0,179,218.54Z",
    style: {
      opacity: 0.07
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--umbrella--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.69,163.61c5.92-2.69,20.53-3.68,30.15-2.87C89,156.28,106.77,149.51,118.56,147l-6.12-16.16-9-23.89C79.88,121.43,62.53,135.05,48.69,163.61Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.69,163.61c5.92-2.69,20.53-3.68,30.15-2.87C89,156.28,106.77,149.51,118.56,147l-6.12-16.16-9-23.89C79.88,121.43,62.53,135.05,48.69,163.61Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.69,163.61c5.92-2.69,20.53-3.68,30.15-2.87-.49-25,9.19-43.09,22.83-52.67A177.85,177.85,0,0,0,48.69,163.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.44,130.8l1.87,4.92c-10.45,2.47-24,7.59-35.26,16.88-10.39.78-26.58,8.23-30.36,11C48.69,163.61,68.36,140,112.44,130.8Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,113.15c-6.22,1.9-17.82,10.83-24.5,17.81-10.57,3.39-28.42,10.11-38.94,16l-6.12-16.16-9-23.89C130.64,102.21,152.71,100.91,182,113.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,113.15c-6.22,1.9-17.82,10.83-24.5,17.81-10.57,3.39-28.42,10.11-38.94,16l-6.12-16.16-9-23.89C130.64,102.21,152.71,100.91,182,113.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,113.15c-6.22,1.9-17.82,10.83-24.5,17.81-16.15-19-35.42-26.2-52-24.35A177.94,177.94,0,0,1,182,113.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,113.15c-6.22,1.9-17.82,10.83-24.5,17.81-16.15-19-35.42-26.2-52-24.35A177.94,177.94,0,0,1,182,113.15Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.44,130.8l1.87,4.92c9.45-5.07,23-10.21,37.65-10.72,8.3-6.3,25.37-11.43,30-11.85C182,113.15,151.59,108.54,112.44,130.8Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.16,108.15l61,181a.77.77,0,0,0,.63.44,2.37,2.37,0,0,0,2-.71.73.73,0,0,0,.22-.73l-61-181Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.4,108.06l.24-.13.29-.16a2,2,0,0,0,.23-.17c.34-.24.13-.35.08-.57-.14-.42-.36-1-.61-1.73-.52-1.43-1.25-3.32-2-5.19-.38-.93-.8-1.86-1.19-2.73-.21-.43-.39-.86-.58-1.25L100.28,95c-.17-.34-.34-.65-.48-.93s-.27-.52-.38-.72c-.21-.39-.34-.61-.34-.61l.11.7.15.79c.06.31.12.65.21,1s.17.77.26,1.2.21.87.32,1.34c.23.93.48,1.91.76,2.88.54,2,1.15,3.89,1.63,5.34l.58,1.73c.11.2,0,.42.43.4a2.72,2.72,0,0,0,.28,0l.32-.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.69,163.61a85.27,85.27,0,0,1,28.43-14.38c10.68-8.85,28.21-13.95,36.61-15L103.4,106.9C84.26,116.26,62.53,135.05,48.69,163.61Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.12,149.23c10.68-8.85,28.21-13.95,36.61-15L103.4,106.9C95,112.27,88.5,123,84,132.16A130.77,130.77,0,0,0,77.12,149.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.94,113.17a85.25,85.25,0,0,0-30.83,8c-13.86.44-30.37,8.23-37.38,13L103.4,106.9C123.93,101.25,152.65,100.93,181.94,113.17Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.11,121.22c-13.86.44-30.37,8.23-37.38,13L103.4,106.9c9.83-1.52,21.8,2.19,31.24,6.09A129,129,0,0,1,151.11,121.22Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167,288.12l-18.38-54.55c-1.13-.13-2.25-.29-3.37-.47l18.87,56a.77.77,0,0,0,.63.44,2.37,2.37,0,0,0,2-.71A.75.75,0,0,0,167,288.12Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.62,233.57l-1-3c-1.14-.15-2.27-.33-3.4-.52l1,3.08C146.37,233.28,147.49,233.44,148.62,233.57Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--orange-slice--inject-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--orange-slice--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.3,356.25s1.36,7.36,1.73,10.37c1.17,9.56-14.85,25.17-39.24,25.17,0,0,12-1.23,19.95-9.17s11.89-24.84,11.89-24.84Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.3,356.25s1.36,7.36,1.73,10.37c1.17,9.56-14.85,25.17-39.24,25.17,0,0,12-1.23,19.95-9.17s11.89-24.84,11.89-24.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--orange--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55,308.71l-4.17,2.39A86,86,0,0,0,53.5,340c8.42,31.91,32.12,53.34,52.94,47.85l.41-.11c12-3.39,20.41-15.14,23.58-30.67l4-2.48Z",
    style: {
      fill: "#407BFF",
      opacity: 0.9500000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.43,357.08c-3.17,15.53-11.55,27.28-23.58,30.67l-.41.11C85.62,393.35,61.92,371.92,53.5,340a86,86,0,0,1-2.72-28.91Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.43 357.08 134.44 354.6 54.95 308.71 50.78 311.1 130.43 357.08",
    style: {
      fill: "#fff",
      opacity: 0.9500000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.15,358.66c-3.55,17.36-12.65,28.43-25.47,32l-.46.13a29.46,29.46,0,0,1-7.43,1c-20.74,0-41.45-21.45-49.25-51a97,97,0,0,1-2.48-31.27l2.72,1.57A86,86,0,0,0,53.5,340c8.42,31.91,32.12,53.34,52.94,47.85l.41-.11c12-3.39,20.41-15.14,23.58-30.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.37,335.24c-2.75.72-6.09-3.71-6.75-9-.13-1.06-.25-1.86-.34-3.17-.26-3.78.4-6.63,4.37-4.67l17.27,9.87c.9.74,1.09,2.84.28,3.05Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--mascara--inject-21",
    d: "M72.47,361.25c-1.37,3.59-4.87,2.83-7.19-1.59Q64.08,357.4,63,355c-.74-1.65-1.45-3.33-2.11-5-1.87-4.83-1.06-10,1.59-10.73l17.86-4.72c.81-.21,1.68,1.7,1.26,2.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.78,372.64c.47,5.24-2,8.22-5.11,6-.61-.45-1.23-.92-1.84-1.43s-1.22-1-1.82-1.6c-3-2.79-4.55-9.13-3.15-12.82l7.59-19.89c.41-1.1,1.63-.09,1.77,1.46Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--mascara--inject-21",
    d: "M106.13,370.5c2.35,4.55,1.52,10.3-1.78,11.73a26.89,26.89,0,0,1-3.6,1.25,26.33,26.33,0,0,1-3.75.69c-3.58.38-7.13-4.21-7.34-9.33l-2.6-34.77c-.07-1.58,1.37-1.95,2.09-.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.51,339.47l22.78,13c4.22,2.4,6.17,9.05,3.91,13.45-.45.88-.93,1.74-1.43,2.58s-1,1.65-1.56,2.44c-2.71,3.92-8,2.86-10.66-2.12L94.06,341.9C93.27,340.42,94.26,338.75,95.51,339.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.45
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.37,335.24c-2.75.72-6.09-3.71-6.75-9-.13-1.06-.25-1.86-.34-3.17-.26-3.78.4-6.63,4.37-4.67l17.27,9.87c.9.74,1.09,2.84.28,3.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--mascara--inject-21",
    d: "M72.47,361.25c-1.37,3.59-4.87,2.83-7.19-1.59Q64.08,357.4,63,355c-.74-1.65-1.45-3.33-2.11-5-1.87-4.83-1.06-10,1.59-10.73l17.86-4.72c.81-.21,1.68,1.7,1.26,2.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.78,372.64c.47,5.24-2,8.22-5.11,6-.61-.45-1.23-.92-1.84-1.43s-1.22-1-1.82-1.6c-3-2.79-4.55-9.13-3.15-12.82l7.59-19.89c.41-1.1,1.63-.09,1.77,1.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--mascara--inject-21",
    d: "M106.13,370.5c2.35,4.55,1.52,10.3-1.78,11.73a26.89,26.89,0,0,1-3.6,1.25,26.33,26.33,0,0,1-3.75.69c-3.58.38-7.13-4.21-7.34-9.33l-2.6-34.77c-.07-1.58,1.37-1.95,2.09-.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.51,339.47l22.78,13c4.22,2.4,6.17,9.05,3.91,13.45-.45.88-.93,1.74-1.43,2.58s-1,1.65-1.56,2.44c-2.71,3.92-8,2.86-10.66-2.12L94.06,341.9C93.27,340.42,94.26,338.75,95.51,339.47Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "48.06 309.53 52.33 307.19 134.44 354.6 137.3 356.25 133.15 358.65 48.06 309.53",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.43 357.08 134.44 354.6 54.95 308.71 50.78 311.1 130.43 357.08",
    style: {
      fill: "#fff",
      opacity: 0.9500000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.78,369.43,87.22,339.22a1.82,1.82,0,0,0-.16.85l2.6,34.77a11.17,11.17,0,0,0,3.91,8.22,3.9,3.9,0,0,0,1.08,0,25.06,25.06,0,0,0,7.35-1.94C105.3,379.73,106.13,374,103.78,369.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.94,351.36l-21.15-12c-.86.12-1.36,1.4-.73,2.57l14.49,26.88a9.56,9.56,0,0,0,2.86,3.3,5.08,5.08,0,0,0,5.45-2.25c.54-.78,1.06-1.6,1.56-2.44s1-1.7,1.43-2.58C122.1,360.41,120.16,353.77,115.94,351.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.43,371.57,82,344.2l-7.09,18.59c-1.4,3.69.15,10,3.15,12.82.6.56,1.21,1.1,1.82,1.6s.94.74,1.4,1.09C83.34,378.36,84.8,375.66,84.43,371.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.24,336.23a2.36,2.36,0,0,0,0-1.44l-16.76,4.43c-2.65.7-3.46,5.9-1.59,10.73.66,1.71,1.37,3.39,2.11,5s1.49,3.16,2.29,4.67a9.53,9.53,0,0,0,2.11,2.8c1.13,0,2.13-.72,2.72-2.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,334.17l14.84-3.91c.81-.22.62-2.31-.28-3.06l-16.34-9.33c-2.7-.64-3.17,1.93-2.95,5.2.09,1.31.21,2.11.34,3.17a13.25,13.25,0,0,0,3.74,8A2.36,2.36,0,0,0,60,334.17Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cloud--inject-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.21,69.83,365,71.31V62.86c0-6.7,5.34-8.3,11.14-5h0c5.8,3.34,10.5,11.49,10.5,18.18v1.23a5.67,5.67,0,0,1,4.88.75h0a16.71,16.71,0,0,1,7.55,13.09v.56l5.35,3.09a11,11,0,0,1,5,8.61c0,3.18-2.23,4.46-5,2.88l-43.25-25a11,11,0,0,1-5-8.62C356.23,69.53,358.46,68.25,361.21,69.83Z",
    style: {
      fill: "#ebebeb"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshingAmico);
export default __webpack_public_path__ + "static/media/Refreshing-amico.f7dff99f1500805b647b20b5738e7976.svg";
export { ForwardRef as ReactComponent };